export default "/images/vendor/flag-icon-css/flags/4x3/kn.svg?a4e974e81853186f152252c4d9c54dbd";